<script setup lang="ts">
import { toRef } from 'vue';
import { useEventStore } from '@/stores/event/event.store';

const eventStore = useEventStore();

const textFont =
  eventStore.getCommonData.textFont &&
  eventStore.getCommonData.textFont.trim() !== ''
    ? eventStore.getCommonData.textFont
    : 'Petit Formal Script';

const pictureText = toRef(() => eventStore.getLangData('pictureText'));
</script>

<template>
  <div class="image">
    <h2 v-if="pictureText" class="text core-default-h2 custom-font">
      {{ pictureText }}
    </h2>
    <div class="circuled">
      <img :src="eventStore.getImages.picture?.url ?? ''" alt="" />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.image {
  margin: 0 auto;
  margin-top: 5px;
  display: flex;
  flex-direction: column;
  gap: 15px;

  .circuled {
    margin: auto;
    width: 95%;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .custom-font {
    font-family: v-bind(textFont), 'Petit Formal Script', serif;
  }
}

.text {
  text-align: center;
  width: 80%;
  margin: auto;
}
</style>
